import { defineComponent as _defineComponent } from 'vue';
import { VContainer, VRow, VCol, VIcon, VSimpleTable, VAlert } from "vuetify/lib";
import DemoSection from '../../components/DemoSection.vue';
import CodePreview from '../../components/CodePreview.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosChipListDemo',
    setup(__props) {
        const items = [
            { id: 1, name: "Vue.js", abreviation: "VUE", colors: { background: '#4FC08D', text: 'white' } },
            { id: 2, name: "React", abreviation: "RCT", colors: { background: '#61DAFB', text: 'black' } },
            { id: 3, name: "Angular", abreviation: "NG", colors: { background: '#DD0031', text: 'white' } },
            { id: 4, name: "Svelte", abreviation: "SVT", colors: { background: '#FF3E00', text: 'white' } },
            { id: 5, name: "Ember", abreviation: "EMB", colors: { background: '#E04E39', text: 'white' } },
        ];
        const propsDocs = [
            { name: 'items', type: 'any[]', required: 'Sí', desc: 'Array de objetos o primitivos a mostrar en la lista.' },
            { name: 'itemText', type: 'string | function', required: 'Sí', desc: 'Nombre de la propiedad o función para obtener el texto a mostrar.' },
            { name: 'itemStyle', type: 'BeosChipStyle', required: 'No', desc: 'Objeto para configurar el aspecto visual de los chips (color, tamaño, etc.).' },
            { name: 'chipConfig', type: 'BeosChipListConfig', required: 'No', desc: 'Objeto de configuración para el comportamiento de la lista (maxLength, truncado, etc.).' },
            { name: 'label', type: 'string', required: 'No', desc: 'Etiqueta opcional para la lista (si aplica).' },
            { name: 'customClass', type: 'string', required: 'No', desc: 'Clases CSS adicionales para el contenedor.' },
        ];
        return { __sfc: true, items, propsDocs, VContainer, VRow, VCol, VIcon, VSimpleTable, VAlert, DemoSection, CodePreview };
    }
});
